<template>
  <div v-if="item.trackLotNumber && lot" style="height: 32px" class="align-content-center">
    <span v-if="showIcon">
      <img src="/mat-sig/lot.svg" alt="Expiration" class="me-1" style="height: 2em;" />
    </span>
    <svg v-if="userSettingsStore.data.showLotVisual" class="d-print-none" version="1.1" width="1em" height="1em" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="cut-off">
        <rect x="0" y="0" width="1em" height=".5em"/>
      </clipPath>
      <circle cx=".5em" cy=".5em" r=".5em" :fill="'#'+hashHexColor(lot)"/>
      <circle cx=".5em" cy=".5em" r=".5em" :fill="'#'+hashHexColor((lot ?? '') + '0')" clip-path="url(#cut-off)"/>
    </svg>
    <span v-for="(seg,i) in lotSegments" :key="i" class="font-monospace fw-bold" :class="seg.cls">{{ seg.text }}</span>
  </div>
  <div v-else-if="item.trackLotNumber && !lot && warnEmpty" class="text-warning align-content-center" style="height: 32px"><font-awesome-icon :icon="['fas', 'square-dashed']" /></div>
  <div v-else style="height: 32px">&nbsp;</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Item from "@/models/frontend/Item";
import { hashHexColor } from '@/services/colors';
import { useUserSettingsStore } from '@/stores';

const userSettingsStore = useUserSettingsStore();

const props = defineProps({
  item: { type: Object as () => Item, required: true },
  lot: { type: String, required: false },
  showIcon: { type: Boolean, default: false },
  warnEmpty: { type: Boolean, default: false }
});

const characterClass = (c: string) => {
  if (c.match(/[a-zA-Z]/)) return 'text-primary';
  if (c.match(/\d/)) return 'text-melodi';
  if (c.match(/\s/)) return 'text-info text-decoration-underline';
  return 'text-danger';
};

const lotSegments = computed(() => {
  const segments: { text: string; cls: string }[] = [];
  for (const c of props.lot ?? '') {
    const cls = characterClass(c);
    const last = segments[segments.length - 1];
    if (last && last.cls === cls) last.text += c;
    else segments.push({ text: c, cls });
  }
  return segments;
});
</script>
